import Vue from 'vue'
import Vuex from 'vuex'
import gateway from './gateway'
import VuexPersistence from 'vuex-persist'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state) => ({
    filters: state.filters,
    applied: state.appliedCats
  }),
  key: window.iron_careers.store_key || 'vuex'
})

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [vuexLocal.plugin],
  state: {
    careers: [],
    filters: {},
    applied: {},
    found: {},
    total: 0
  },
  getters: {
    getFilters: state => {
      return state.filters
    },
    getApplied: state => {
      return state.applied
    },
    getOffset: state => {
      return state.careers.length
    },
    getTotal: state => {
      return state.total
    },
    getFound: state => {
      return state.found
    },
    getCareers: state => {
      return state.careers
    }
  },
  mutations: {
    set_store(state, data) {
      state.careers.push(...data)
    },
    update_store(state, data) {
      state.careers = data
    },
    set_filters(state, data) {
      state.filters = data
    },
    set_total(state, data) {
      state.total = data
    },
    set_found(state, data) {
      Vue.set(state, 'found', data)
    },
    set_filter(state, data) {
      Vue.set(state.applied, data.type, data.filter)
    },
  },
  actions: {
    searchTerm(context, data) {
      const result = {
        jobs: [],
        tags: []
      }
      /* filter by categories, add multiple tags */
      const appliedCats = context.getters.getApplied.categories ? context.getters.getApplied.categories : []

      if (data.length) {
        const jobs  = gateway.pullData(0, {categories: appliedCats})
        const tags  = []
        
        jobs.forEach(job => {
          /* reduce duplicates, ignore case */
          let jTags = job.tags.filter(t => tags.map(e => e.toLowerCase()).indexOf(t.toLowerCase()) < 0)
          tags.push(...jTags) 
        })
        
        result.tags = tags.filter((v, i, a) => a.indexOf(v) === i && v.toLowerCase().indexOf(data.toLowerCase()) >= 0).slice(0, 6)
        result.jobs = jobs.filter(e => e.title.toLowerCase().indexOf(data.toLowerCase()) >= 0).slice(0, 6)
      }

      context.commit('set_found', result)
    },
    getFilters(context) {
      gateway.getFilters().then(e => context.commit('set_filters', e))
    },
    applyFilter(context, data) {
      const toggle    = data.toggle || false
      const applied   = context.getters.getApplied
      let propFilters = applied[data.type] || []
      const offset    = propFilters.indexOf(data.filter)

      if (!toggle && offset >= 0) {
        propFilters.splice(offset, 1)
      } else {
        propFilters = toggle ? [data.filter] : [].concat(propFilters, data.filter)
      }

      context.commit('set_filter', {
        type: data.type,
        filter: propFilters
      })
      
      gateway.getData(0, context.getters.getApplied)
        .then(e => context.commit('update_store', e))
      
      context.dispatch('updateTotal')
    },
    resetFilter(context, data) {
      context.commit('set_filter', {
        type: data.type,
        filter: []
      })
      
      gateway.getData(0, context.getters.getApplied)
        .then(e => context.commit('update_store', e))
      
      context.dispatch('updateTotal')
    },
    updateTotal(context) {
      context.commit('set_total', gateway.pullData(0, context.getters.getApplied).length || 0)
    },
    getData(context, init) {
      if (init && context.getters.getOffset > 0)
        return

      gateway.getData(context.getters.getOffset, context.getters.getApplied).then(e => context.commit('set_store', e))
      context.dispatch('updateTotal')
    }
  }
})
